'use client'

import { useEffect } from 'react'
import { initPostHog, setupSessionIdleTracking } from '@/lib/analytics'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initPostHog()
    return setupSessionIdleTracking()
  }, [])

  return <>{children}</>
}
